function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-start;\n  padding: 1rem 1.2rem;\n  padding-left: 0px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CustomNav from '../../atoms/CustomNav';
import { defaultTheme } from '../../../utils';
var StyledTab = styled.div(_templateObject());

var Tabs = function Tabs(_ref) {
  var links = _ref.links,
      variant = _ref.variant,
      rest = _objectWithoutPropertiesLoose(_ref, ["links", "variant"]);

  return /*#__PURE__*/React.createElement(StyledTab, rest, links.map(function (link, index) {
    return /*#__PURE__*/React.createElement(CustomNav, _extends({
      key: index
    }, link, {
      variant: variant
    }));
  }));
};

Tabs.propTypes = process.env.NODE_ENV !== "production" ? {
  links: PropTypes.array,
  variant: PropTypes.string
} : {};
Tabs.defaultProps = {
  theme: defaultTheme,
  variant: 'contained'
};
export default Tabs;